<div class="card" id="card">
  <div class="head">
    <div class="title">
      <span class="icon">
        <ng-icon name="{{ icon() }}" size="20"></ng-icon>
      </span>
      <p>{{ title() }}</p>
    </div>
  </div>
  <div class="body" [ngClass]="{ opened: isOpened }">
    <div #ref><ng-content></ng-content></div>

    @if (ref.children.length === 0) {
    <div>
      @if (loading()) {
      <div class="skeleton-loader">
        <div class="skeleton-info"></div>
        <div class="skeleton-items">
          <div class="skeleton-item"></div>
        </div>
      </div>
      } @else if (hasError()) {
      <app-error-state
        [message]="errorMessage()"
        [retryButtonText]="retryButtonText()"
        (onRetry)="onRetry.emit()"
      ></app-error-state>
      } @else {
      <h5 class="info">
        {{ info() }}
        @if (accordionContent()?.sub) {
        <sub>{{ accordionContent()?.sub }}</sub>
        }
      </h5>
      @if (accordionContent != undefined) {
      <div class="accordion-content">
        @for (item of accordionContent()?.items; track item.icon) {
        <div class="item">
          <span class="icon">
            <ng-icon name="{{ item.icon }}" size="18"></ng-icon>
          </span>
          <div class="content">
            <p class="title">
              {{ item.title }}
              @if (item.sub) {
              <sub>{{ item.sub }}</sub>
              }
            </p>
            <small class="description">{{ item.description }}</small>
          </div>
        </div>
        }
      </div>
      } @if (accordionContent()?.items?.length) {
      <button class="expand-arrow" (click)="toggle()">
        <ng-icon name="iconoirNavArrowDown" size="22" strokeWidth="2"></ng-icon>
      </button>
      }
      }
    </div>
    }
  </div>
</div>
